/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import { withRouter } from 'react-router';
import { object, string, array } from 'prop-types';
import { compose } from 'recompose';
import loadable from '@loadable/component';

import TemplateMasterPage from './TemplateMasterPage';
import UnderNavTextWidgetContainer from '../GraphqlCommonComponents/GraphqlUnderNavTextWidget/GraphqlUnderNavTextWidgetContainer';
import GraphqlSeoHeadTags from '../GraphqlCommonComponents/GraphqlSeoHeadTags/GraphqlSeoHeadTags';

import { coreBrowsingPageViewSuccessTest } from '../../../helpers/tracking/common/commonTrackingHelpers';
import withPageView from '../../../helpers/tracking/hocs/withPageView';

const LoadableCorporateGiftingPage = loadable(() => import(/* webpackChunkname: "CorporateGiftingPage" */ '../CorporateGifting/CorporateGiftingPage'));

const GraphqlMasterTemplatePageBody = ({
    brand,
    blocks,
    seo,
    page,
    ssrDeviceType,
    presentationFamily,
    code,
}) => {
    if (brand?.code === 'PLA') {
        switch (page?.path) {
            case '/corporate-gifting-details':
                return <LoadableCorporateGiftingPage code={code} brand={brand} blocks={blocks} seo={seo} />;
            default:
                return null;
        }
    }

    return (
        <>
            {seo?.seo_searchable
                ? (
                    <GraphqlSeoHeadTags seoData={seo} alternativeLang="true" />
                ) : null}
            <UnderNavTextWidgetContainer page={page} presentationFamily={presentationFamily} />
            {
                blocks
                    ? (
                        <TemplateMasterPage
                            page={page}
                            brand={brand}
                            block={blocks}
                            ssrDeviceType={ssrDeviceType}
                            presentationFamily={presentationFamily}
                        />
                    )
                    : null
            }
        </>
    );
};

GraphqlMasterTemplatePageBody.propTypes = {
    brand: object.isRequired,
    ssrDeviceType: string.isRequired,
    blocks: array,
    seo: object,
    page: object.isRequired,
    presentationFamily: string.isRequired,
    code: string,
};

GraphqlMasterTemplatePageBody.defaultProps = {
    blocks: [],
    seo: {},
    code: '',
};

const enhance = compose(
    withRouter,
    withPageView({
        pageViewSuccessTest: coreBrowsingPageViewSuccessTest,
    }),
);

export default enhance(GraphqlMasterTemplatePageBody);
